import { ReactNode } from 'react';
import { MdCheckCircle, MdWarningAmber } from 'react-icons/md';

export interface KpiTileData {
  label: string;
  note?: string;
  value: ReactNode;
  unit?: string;
  // A badge highlights the tile (green 'strong' / amber 'weak' border + inline chip).
  badge?: { text: string; kind: 'strong' | 'weak' };
}

// Shared KPI stat bar (matches the Streamlit prototype): a row of tiles, each a
// grey box with a label, big value, optional unit suffix, and an optional
// strong/weak badge that also highlights the tile border.
export const KpiBar = ({ tiles }: { tiles: KpiTileData[] }) => (
  <div
    className='data-qa-kpi'
    style={{ gridTemplateColumns: `repeat(${tiles.length}, minmax(0, 1fr))` }}
  >
    {tiles.map(tile => (
      <div
        key={tile.label}
        className={`data-qa-kpi__tile${tile.badge ? ` data-qa-kpi__tile--${tile.badge.kind}` : ''}`}
      >
        <div className='data-qa-kpi__label'>
          {tile.label}
          {tile.note && <span className='data-qa-kpi__note'> {tile.note}</span>}
        </div>
        <div className='data-qa-kpi__value-row'>
          <span className='data-qa-kpi__value'>
            {tile.value}
            {tile.unit && <span className='data-qa-kpi__unit'> {tile.unit}</span>}
          </span>
          {tile.badge && (
            <span className={`data-qa-kpi__badge data-qa-kpi__badge--${tile.badge.kind}`}>
              {tile.badge.kind === 'strong' ? <MdCheckCircle /> : <MdWarningAmber />}
              {tile.badge.text}
            </span>
          )}
        </div>
      </div>
    ))}
  </div>
);
